/**************************************************
 * Nombre:       Formacion_Contactos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import fondo from "../../../Recursos/fondo_contactos.png";
import {CONTACTOS, NEGRITA} from "../../../Constantes";
import Tarjeta_Docente from "../../Tarjetas/Tarjeta_Docente";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {irUrl} from "../../../Utilidades/irUrl";
import {useEffect, useState} from "react";
import Boton from "./Subcomponentes/Boton";
import {useDialogo} from "../../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Registro from "../../Dialogos/Dialogo_Registro";

const Formacion_Contactos = ({item}) => {
    const {sCell, masSM} = useResponsive()
    const [profes, setProfes] = useState([])
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Registro, titulo: 'Formulario de Registro'})

    const abrirRegistro = () => {

        abrir(item);
    }

    useEffect(() => {

        if (item.profesores) {
            setProfes(item.profesores)
        }

    }, [item])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Dialogo/>

            <Grid container size={{xs: 12, sm: 12, md: 7}} sx={{justifyContent: 'flex-start', p: sCell ? 3 : 6}}>
                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'center'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={4}
                >

                    {profes.map((item, index) => (
                        <Grid container size={{xs: 6, sm: 3, md: 3}} sx={{justifyContent: 'flex-start'}}>
                            <Tarjeta_Docente item={item}/>
                        </Grid>
                    ))}

                </Grid>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 5}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{
                        background: `linear-gradient(180deg, rgba(48, 51, 118, 0.85) 0%, rgba(48, 51, 118, 0.85) 100%), url(${fondo})`,
                        backgroundPosition: 'center center',
                        backgroundSize: 'cover',
                        p: sCell ? 4 : 6,
                        color: '#fff',
                        pb: 12

                    }}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontFamily: NEGRITA, fontSize: sCell ? 32 : 40}}>Contactos</Typography>
                    </Grid>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        {CONTACTOS.map((contacto) => (
                            <Grid
                                onClick={() => irUrl(contacto.url)}
                                container size={{xs: 12, sm: 12, md: 12}}
                                sx={{
                                    justifyContent: 'flex-start',
                                    cursor: 'pointer',
                                }}
                            >
                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}
                                    sx={{borderBottom: 1, borderColor: '#fff', p: sCell ? 1 : 3}}
                                >

                                    <Typography sx={{fontSize: sCell ? 12 : 16}}>
                                        <span>
                                            <img src={contacto.img} width={18} height={'auto'}
                                                 style={{marginRight: 10, marginTop: 2, marginBottom: -2,}}/>
                                        </span>
                                        {contacto.descripcion}
                                    </Typography>

                                </Grid>
                            </Grid>
                        ))}

                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 6}}>
                        <Typography sx={{fontWeight: 300, fontSize: sCell ? 14 : 20}}>
                            <span style={{fontWeight: 600}}>¡Inicie su formación con nosotros hoy mismo </span>
                            y conviertente en un verdadero gestor de paz
                            desde las MASC!
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 6}}>

                        <Boton click={abrirRegistro}
                               texto={'Obtener mi Certificado'}/>
                    </Grid>

                </Grid>
            </Grid>

        </Grid>
    )

}
export default Formacion_Contactos

const items = [
    {
        nombre: 'Esp Andrés Felipe Ordóñez Pantoja',
        descripcion: 'Abogado especialista en Derecho Penal y Administrativo'
    },
    {
        nombre: 'Esp Andrés Felipe Ordóñez Pantoja',
        descripcion: 'Abogado especialista en Derecho Penal y Administrativo'
    },
    {
        nombre: 'Esp Andrés Felipe Ordóñez Pantoja',
        descripcion: 'Abogado especialista en Derecho Penal y Administrativo'
    },
    {
        nombre: 'Esp Andrés Felipe Ordóñez Pantoja',
        descripcion: 'Abogado especialista en Derecho Penal y Administrativo'
    },
]